import * as React from 'react'
import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'

import AutoFixHighRoundedIcon from '@mui/icons-material/AutoFixHighRounded'
import Diversity3Icon from '@mui/icons-material/Diversity3';
import VpnLockIcon from '@mui/icons-material/VpnLock'

import Logo from "../../components/Logo";

const items = [
  {
    icon: <AutoFixHighRoundedIcon sx={{ color: 'text.secondary' }} />,
    title: 'Intelligent',
    description:
        'Notre IA vous proposera automatiquement les tâches les plus pressantes ⏰. Peut importe votre appareil, tout est synchronisé.',
  },
  {
    icon: <Diversity3Icon sx={{ color: 'text.secondary' }} />,
    title: 'Collaboratif',
    description:
        "Que ce soit en famille ou entre associés, partagez vos données, répartissez les tâches, et avancez plus vite 👍.",
  },
  {
    icon: <VpnLockIcon sx={{ color: 'text.secondary' }} />,
    title: 'Français',
    description:
        "Dormez sereins, vos données sont stockées en France 🇫🇷. Et nulle part ailleurs.",
  },
]

export default function Content() {
  return (
    <Stack
      sx={{ flexDirection: 'column', gap: 4, maxWidth: 450 }}
    >

      <Logo/>

      {items.map((item, index) => (
        <Stack key={index} direction="row" sx={{ gap: 2 }}>
          {item.icon}
          <div>
            <Typography gutterBottom sx={{ fontWeight: 'medium' }}>
              {item.title}
            </Typography>
            <Typography variant="body2" sx={{ color: 'text.secondary' }}>
              {item.description}
            </Typography>
          </div>
        </Stack>
      ))}
    </Stack>
  )
}
